import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  BillingPatientTableContent,
  IBillablePatient,
} from "../../../../@types/Patient";
import { TableSkeleton } from "../../../../components/TableSkeleton";
import { TableSorted } from "../../../../components/TableSorted";

type PatientListTableProps = {
  content: BillingPatientTableContent[];
  isLoading?: boolean;
  columns: ColumnDef<any, string>[];
};

export function BillingTable({
  content,
  isLoading = false,
  columns,
}: PatientListTableProps) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleRowClick = (patientContent: IBillablePatient) => {
    navigate(`/patients/${patientContent.pmpId}`);
  };

  const emptyStateText = t("billing_emptyState");

  if (isLoading) {
    return <TableSkeleton columnsNumber={8} />;
  }

  return (
    <TableSorted
      data={content}
      onRowClick={handleRowClick}
      emptyStateText={emptyStateText}
      columns={columns}
    />
  );
}
